import { APP_MYPROFILE_SERVER_URL } from ':constants';

export const SERVICES_PAGE = '/showcase/api/v1/services/page';
export const MENU_ITEMS_LIST = '/showcase/api/v1/services/menu';
export const WIDGETS_LIST_URL = '/showcase/api/v1/widgets';
// FIXME: put the correct url after back api
export const FOOTER_LINKS_URL = '/showcase/api/v1/footer';
export const CATALOG_CATEGORIES = '/showcase/api/v1/categories';
export const CATALOG_SERVICES = '/showcase/api/v1/services';

export const SHOWCASE_INFO = '/showcase/api/v1/showcase';

export const MYPROFILE_EMPLOYEE_INFO = (employeeNumber: string | number) =>
  `${APP_MYPROFILE_SERVER_URL}/api/v1/employees?employee_number=${employeeNumber}&fields=first_name`;
